/**
 * App name and logos for the website. Change them here: the sidebar, login page, footer,
 * browser tab title, meta description and favicon all follow.
 *
 * logo       Full logo (icon + wordmark), shown on the login card, the expanded sidebar and the footer.
 *            Path to an image in webapp/public, e.g. 'brand/vintech-logo.png'.
 * logoMark   Square icon-only logo, shown when the sidebar is collapsed. Leave '' to use logoIcon.
 * logoIcon   Font Awesome classes used when there is no logoMark image.
 * favicon    Path to the tab icon in webapp/public.
 */
export interface Branding {
  appName: string;
  description: string;
  logo: string;
  logoMark: string;
  logoIcon: string;
  favicon: string;
}

export const BRANDING: Branding = {
  appName: 'Vintech Central Portal',
  description: 'Vintech Central Portal',
  logo: 'brand/vintech-logo.png',
  logoMark: 'brand/vintech-icon.png',
  logoIcon: 'fa-solid fa-layer-group',
  favicon: 'favicon.png',
};

/** Applies the name, description and favicon to the page head (called once from main.ts). */
export function applyDocumentBranding(): void {
  document.title = BRANDING.appName;
  document.querySelector('meta[name="description"]')?.setAttribute('content', BRANDING.description);
  const icon = document.querySelector('link[rel="icon"]');
  icon?.setAttribute('href', BRANDING.favicon);
  icon?.setAttribute('type', BRANDING.favicon.endsWith('.png') ? 'image/png' : 'image/x-icon');
}
